if (!customElements.get('variant-selects')) {
    customElements.define(
        'variant-selects',
        class VariantSelects extends HTMLElement {
            constructor() {
                super();
            }

            get selectedOptionValues() {
                return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
                    ({
                        dataset
                    }) => dataset.optionValueId
                );
            }

            getInputForEventTarget(target) {
                return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
            }

            connectedCallback() {
                this.addEventListener('change', (event) => {
                    const target = this.getInputForEventTarget(event.target);
                    this.updateSelectedSwatchValue(event);
                    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
                        data: {
                            event,
                            target,
                            selectedOptionValues: this.selectedOptionValues,
                        },
                    });
                    document.dispatchEvent(
                        new CustomEvent('variant:changed', {
                            detail: {
                                variant: this.currentVariant,
                            },
                        })
                    );
                });
                var customer_selector = document.querySelector(".customer-selector");
                console.log("customer_selector", customer_selector);
                var changed_value = customer_selector ? customer_selector.querySelector(".change-variant-selector") : null;
                var icon = customer_selector ? customer_selector.querySelector("svg") : null;
                var option_list = document.querySelector(".custom-makeup-variant-list");
                var options = option_list ? option_list.querySelectorAll("li") : null;
                options ? options.forEach(option => {
                    option.addEventListener("click", () => {
                        var change_value = option.innerHTML;
                        var self_value = option.dataset.value;
                        var color_swatch = document.querySelector(`variant-selects fieldset label[data-option='${self_value}']`);
                        if (color_swatch) color_swatch.click();
                        changed_value ? changed_value.innerHTML = change_value : null;
                        customer_selector ? customer_selector.classList.remove("active") : null;
                        option_list ? option_list.style.maxHeight = '0' : null;
                        icon ? icon.classList.remove('active') : null;
                    })
                }) : null;
                customer_selector ? customer_selector.addEventListener("click", () => {
                    const option_list = customer_selector.closest('.select').querySelector('.custom-makeup-variant-list');
                    console.log("clicked", option_list);
                }) : null;
                var variant_swatches = document.querySelectorAll("variant-selects label[data-swatch-type='color_swatch']");
                console.log("variant_swatches", variant_swatches);
                variant_swatches ? variant_swatches.forEach(item => {
                    item.addEventListener("click", () => {
                        console.log("item clicked");
                        var active_item = document.querySelector("variant-selects label[data-swatch-type='color_swatch'].active");
                        if (active_item) {
                            active_item.classList.remove("active");
                        }
                        item.classList.add("active");
                        var self_value = item.dataset.option;
                        var option = document.querySelector(`.custom-makeup-variant-list li[data-value='${self_value}']`);
                        var self_media = document.querySelector(`.product-animation-video-thumbnail[data-position='${self_value}']`);
                        console.log("self_media", self_media);
                        if (self_media) {
                            self_media.click();
                        };

                    })
                }) : null;
            }

            updateSelectedSwatchValue({
                target
            }) {
                const {
                    value,
                    tagName
                } = target;

                if (tagName === 'SELECT' && target.selectedOptions.length) {
                    Array.from(target.options)
                        .find((option) => option.getAttribute('selected'))
                        .removeAttribute('selected');
                    target.selectedOptions[0].setAttribute('selected', 'selected');

                    const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
                    const selectedDropdownSwatchValue = target
                        .closest('.product-form__input')
                        .querySelector('[data-selected-value] > .swatch');
                    if (!selectedDropdownSwatchValue) return;
                    if (swatchValue) {
                        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
                        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
                    } else {
                        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
                        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
                    }

                    selectedDropdownSwatchValue.style.setProperty(
                        '--swatch-focal-point',
                        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
                    );
                } else if (tagName === 'INPUT' && target.type === 'radio') {
                    const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
                    if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
                }
            }
        }
    );
}